<template>
  <div class="index_incidents">
    <div class="incidents_main" v-infinite-scroll="loadMore">
      <el-row
        style="margin:0 0 1vh 10%;width:90%;"
        v-for="(item,index) in incidents"
        :key="item.id">
        <el-col :span="24">
          <el-row v-if="index===0 || item.recordTime !== incidents[index-1].recordTime">
            <el-col>
              <el-link type="primary" style="font-size:1.1rem;"><el-icon class="el-icon-time"></el-icon> {{new Date(item.recordTime*1000).toLocaleDateString()}}</el-link>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-card>
                <div style="display: inline-block;width:100%;"
                     @click="getDetail(item.incidentId)">
                  {{item.inciTitle}}
                </div>
                <div class="incidents_cate incidents_cate_location">
                  {{item.org}}
                </div>
                <div :class="`incidents_cate incidents_cate_`+item.typeId">
                  {{item.tags}}
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="incident_bottom">
      <el-row>
        <el-col :span="12">
          <el-select style="width:90%;margin:0 5%;" multiple collapse-tags size="mini" v-model="taged" @visible-change="tagedChange" placeholder="请选择类型">
            <el-option :value="item.typeId" :label="item.tags" v-for="item in tags" :key="item.typeId">{{item.tags}}</el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-select style="width:90%;margin:0 5%;" :clearable="true" size="mini" v-model="orged" @visible-change="orgedChange" @clear="orgedClear" placeholder="请选择地区">
            <el-option :value="item.org" :label="item.org" v-for="(item,index) in orgs" :key="index">{{item.org}}</el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :visible.sync="incidentsDialogVisible"
      :fullscreen="true"
      @close="closeDetail">
      <div class="incidents_detail_title">
        {{incident.inciTitle}}
      </div>
      <div class="incidents_detail_head">
        海事局：{{incident.orgName}} 日期：{{new Date(incident.recordTime * 1000).toLocaleDateString()}}
      </div>
      <div :class="`incidents_detail_cate incidents_cate_`+incident.typeId">
        {{incident.tags}}
      </div>
      <div class="incidents_detail_content" v-html="incident.inciConte">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="incidentsDialogVisible = false">返 回 列 表</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getIncidentsList, getIncidentDetail,getIncidentsTags,getIncidentsOrgs } from '../../api/api'
  export default {
    name: "IndexIncidents",
    data() {
      return {
        id:this.$route.query.id,
        page: 1,
        size:20,
        loading:false,
        incidents:[],
        incident:{},
        incidentsDialogVisible: false,
        tags:[],
        orgs:[],
        taged:[],
        orged:null,
      }
    },
    mounted(){
      window.addEventListener('popstate',()=>{
        if(this.incidentsDialogVisible){
          this.closeDetail();
          this.incidentsDialogVisible = false;
        }
      },false);
      getIncidentsTags().then(res => {
        if(res && res.status === 0){
          this.tags = res.data;
        }
      });
      getIncidentsOrgs().then(res => {
        if(res && res.status === 0){
          this.orgs = res.data;
        }
      });
      if (this.id && this.id > 0) {
        this.getDetail(this.id);
      }
    },
    methods: {
      loadMore(){
        if(!this.loading){
          this.loading = true;
          let params = {page:this.page,size:this.size};
          if(this.taged && this.taged.length > 0) params['typeIds'] = this.taged.join(',');
          if(this.orged && this.orged != null && this.orged !== '') params['org'] = this.orged;
          getIncidentsList(params).then(res => {
            if(res && res.status===0 && res.data){
              for(let d in res.data){
                this.incidents.push(res.data[d]);
              }
              this.page++;
            }
            this.loading = false;
          });
        }
      },
      getDetail(id){
          getIncidentDetail(id).then(res => {
            if(res && res.status === 0){
              this.incidentsDialogVisible = true;
              this.incident = res.data;
              if (!this.id || this.id !== id) this.$router.push('/index/incident?id=' + id)
            }
          });
      },
      closeDetail(){
        this.$router.push('/index/incident')
      },
      tagedChange(e){
        if(!e){
          this.page = 1;
          this.incidents = [];
          this.loadMore();
        }
      },
      orgedChange(e){
        if(!e){
          this.page = 1;
          this.incidents = [];
          this.loadMore();
        }
      },
      orgedClear(){
        this.page = 1;
        this.incidents = [];
        this.loadMore();
      }
    }
  }
</script>

<style scoped>
  .index_incidents {
    top:6vh;
    left:0;
    position: absolute;
    height:89vh;
    width:100%;
    margin:0;
    background-color:#eee;
    overflow-y: scroll;
  }
  .incidents_detail_title {
    font-weight:bold;
    font-size:1rem;
  }
  .incidents_head {
    margin:0;
    width:100%;
    text-align:center;
    height:3vh;
    line-height:5vh;
    font-size:1.2rem;
    font-weight:bold;
  }
  .incidents_main {
    width:92%;
    margin: 3vh 8% 6vh 0;
  }
  .incidents_detail_head {
    color:grey;
    border-bottom:1px dashed #ccc;
    height:1.5rem;
    line-height:1.5rem;
  }
  .incidents_detail_cate {
    color:#999;
    font-size:.8rem;
    border-bottom:1px solid #ccc;
    height:1.5rem;
    line-height:1.5rem;
  }
  .incidents_detail_content {
    line-height:1.5rem;
    letter-spacing:.1rem;
    font-size:.9rem;
  }
  .incidents_cate {
    display: inline-block;
    height:1rem;
    line-height:1rem;
    width:3rem;
    text-align:center;
    font-size:.6rem;
    border:1px solid grey;
    color:grey;
    border-radius:.3rem;
    float:left;
    margin:.2rem 0 .5rem .15rem;
  }
  .incidents_cate_1 {
    color:rgb(54, 98, 236);
    border-color:rgb(54, 98, 236);
  }
  .incidents_cate_2 {
    color:rgb(250, 81, 81);
    border-color:rgb(250, 81, 81);
  }
  .incidents_cate_3 {
    color:rgb(54, 98, 236);
    border-color:rgb(54, 98, 236);
  }
  .incidents_cate_4 {
    color:rgb(255, 89, 0);
    border-color:rgb(255, 89, 0);
  }
  .incidents_cate_5 {
    color:rgb(0, 181, 120);
    border-color:rgb(0, 181, 120);
  }
  .incidents_cate_6 {
    color:rgb(194, 0, 0);
    border-color:rgb(194, 0, 0);
  }
  .incidents_cate_7 {
    color:rgb(222, 159, 49);
    border-color:rgb(222, 159, 49);
  }
  .incidents_cate_8 {
    color:rgb(0, 182, 182);
    border-color:rgb(0, 182, 182);
  }
  .incidents_cate_9 {
    color:rgb(158, 90, 246);
    border-color:rgb(158, 90, 246);
  }
  .incidents_cate_10 {
    color:rgb(172, 172, 32);
    border-color:rgb(172, 172, 32);
  }
  .incidents_cate_11 {
    color:rgb(73, 176, 250);
    border-color:rgb(73, 176, 250);
  }
  .incidents_cate_12 {
    color:rgb(38, 203, 222);
    border-color:rgb(38, 203, 222);
  }
  .incidents_cate_13 {
    color:rgb(184, 102, 164);
    border-color:rgb(184, 102, 164);
  }
  .incidents_cate_14 {
    color:rgb(255, 123, 130);
    border-color:rgb(255, 123, 130);
  }
  .incidents_cate_0 {
    color:#999;
    border-color:#999;
  }
  .incidents_cate_location {
    color:rgb(6, 112, 185);
    border-color:rgb(6, 112, 185);
  }
  .incident_bottom {
    position:fixed;
    bottom:0;
    left:0;
    width:100%;
    height:5vh;
    line-height:5vh;
    text-align:center;
    background-color:rgba(255,255,255,0.7);
  }
</style>



// WEBPACK FOOTER //
// src/components/index/incident.vue